import React from "react";
import { useHistory, useParams } from "react-router-dom";
import NotificationForm from "./NotificationForm";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../api/api.keys";
import { Helmet } from "react-helmet";
import HeaderWithBackButton from "../../components/HeaderWithBackButton/HeaderWithBackButton";
import { Card, CardBody } from "reactstrap";
import { APP_ROUTES } from "../../helpers/routeHelpers";
import { UpdateNotificationById, GetNotificationById } from "../../api/api.service";
import { hasData } from "../../utils/commonUtils";
import { LoaderFallbackUI } from "../../components/LoaderFallbackUI";
import { NoticationType } from "../../constants";
import { NOTIFICATION_TYPE } from "../../constants/NoticationType";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../constants/SubscriptionStatus";
import { formatScheduledAt } from "../../utils/dateUtils";
import { ERROR, showToast, SUCCESS } from "../../utils/toastUtils";

const Update = () => {
    const history = useHistory();
    let { notificationID } = useParams();
    let { useFetch, useMutate } = useRequestProcessor();

    let { mutate, isLoading: isNotificationUpdated } = useMutate("", getKey(), (data) =>
        UpdateNotificationById(notificationID, data)
    );

    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.UPDATE_NOTIFICATION], { notificationID }),
        async ({ signal }) =>
            await GetNotificationById({
                Id: notificationID
            })
    );

    const updateAudioHandler = (values) => {
        try {
            const bodyData = {
                title: values.title,
                content: values.notificationMessage,
                type:
                    values.notificationType ==
                    NoticationType.getDisplayTextKey(NOTIFICATION_TYPE.PROMOTION)
                        ? NOTIFICATION_TYPE.PROMOTION
                        : NOTIFICATION_TYPE.RECOMMENDATION,
                tierType:
                    values.userGroup ===
                    SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.FREEMIUM)
                        ? SUBSCRIPTION_STATUS.FREEMIUM
                        : values.userGroup ===
                          SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.PREMIUM)
                        ? SUBSCRIPTION_STATUS.PREMIUM
                        : SUBSCRIPTION_STATUS.ALL,
                scheduledAt: formatScheduledAt(values.scheduleDate, values.scheduleTime),
                ageBracketIds: values.ageGroup?.map((ageGroup) => ageGroup.value) || []
            };

            mutate(bodyData, {
                onSuccess: async (res) => {
                    showToast(SUCCESS, "Notification updated successfully");
                    history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
                },
                onError: (err) => {
                    console.log("not cerated", err);
                }
            });
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    const handleBackClick = () => {
        history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
    };

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <div className="page-content">
            <Helmet>
                <title>User Management Details</title>
            </Helmet>
            <HeaderWithBackButton title="Edit Notification" onBackClick={handleBackClick} />
            <Card className="" style={{ borderRadius: "20px" }}>
                <CardBody>
                    <NotificationForm
                        mode="edit"
                        isLoading={isNotificationUpdated}
                        data={data}
                        onUpdateNotification={updateAudioHandler}
                        isDisabled={isNotificationUpdated}
                    />
                </CardBody>
            </Card>
        </div>
    );
};

export default Update;
